<template>
  <div>
    <div class="app-header">
      <div class="bread-crumb">
        <ul class="list-item-container">
          <li v-for="(item, index) in arrayStep" class="list-item" :key="item">
            <a href="javascript:void(0)"
               class="step-name-breadcrumb body-text scheduler-text-custom-color"
               :style="{'font-weight': item === 'Select location'  ? 'bold' : 'normal'}">
              {{item}}
            </a>
            <div class="arrow-icon" v-if="index != arrayStep.length - 1" role="navigation"></div>
          </li>
        </ul>
      </div>
    </div>

    <div class="select-location-container">
      <h1 class="h1-text step-name" tabindex="0" ref="focusTab">Select Location</h1>
      <!-- Header -->
      <div class="more-information common-card scheduler-card-responsive margin-top-24px" v-if="landingTopText !== ''">
        <div class="body-text" v-html="landingTopText"></div>
      </div>
      <!-- Find nearest event -->
      <div class="common-card find-nearest-event-card scheduler-card-responsive">
        <div class="title-box h5-text">Find Nearest Event</div>
        <div class="find-nearest-event row">
          <div class="col-md-6 col-xs-12">
            <div class="body-text">Automatically determine my location</div>
            <div class="btn-find-container-left">
              <button aria-label="Button find Automatically determine my location" class="ap-btn error btn-find scheduler-button-custom-color" role="button">Find</button>
            </div>
          </div>
          <div class="col-md-6 col-xs-12 field-zipcode-container">
            <div class="field-wrapper">
              <div class="body-text">Zip code</div>
              <div class="require-field-icon" aria-label="* field denotes as Mandatory fields.">*</div>
            </div>
            <div class="input-zip-code-container">
              <div class="ap-field-input-wrapper">
                <div class="ap-input-wrapper">
                  <input
                    aria-label="Enter your zip code using the keyboard"
                    ref="inputZipCodeText"
                    id="inputZipCode"
                    aria-labelledby="zipCodeError inputZipCode"
                    class="input"
                    size="5"
                    role="textbox"
                    type="number"
                    placeholder="Ex: 98052"
                    disabled
                  />
                </div>
              </div>
              <div class="">
                <button class="ap-btn error btn-find scheduler-button-custom-color" role="button">Find</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Full List of Locations -->
      <div class="full-list-of-locations-container common-card scheduler-card-responsive">
        <div class="title-list-of-locations-wrapper">
          <div class="title-box h5-text">
            Full list of Locations
          </div>
          <div class="spouse-screening-flushot-container">
            <div class="spouse-screening-flushot-checkbox">
              <div class="bringing-spouse-wrapper">
                <div class="spouse-checkbox checkbox-container">
                  <b-form-checkbox class="ap-checkbox-group scheduler-checkbox-group-custom">Bringing spouse</b-form-checkbox>
                </div>
              </div>
              <div class="biometric-screening-wrapper">
                <div class="screening-checkbox checkbox-container">
                  <b-form-checkbox class="ap-checkbox-group scheduler-checkbox-group-custom">Biometric screening</b-form-checkbox>
                </div>
              </div>
              <div class="flu-shot-wrapper">
                <div class="flu-shot-checkbox checkbox-container">
                  <b-form-checkbox class="ap-checkbox-group scheduler-checkbox-group-custom">Flu shot</b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-availability-of-locations label-text">Availability of locations are dependent biometric screening, and flu shot selections</div>
        <div class="list-of-locations row">
          <template v-for="l in listOfLocations">
            <div class="col-md-3 list-item">
              <a href="javascript:void(0)" tabindex="0" :key="l.id" class="display-inline scheduler-text-custom-color">
                {{l.state + ' - ' + l.city}}
              </a>
              <p v-if="!l.available" class="full-event-text display-inline">- All events are full</p>
            </div>
          </template>
        </div>
      </div>

      <!--Footer -->
      <div class="more-information common-card scheduler-card-responsive margin-top-24px" v-if="landingBottomText !== ''">
        <div class="body-text" v-html="landingBottomText"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'schedulerPreviewSelectLocationPage',
    components: {
    },
    props: {
      landingTopText: {
        type: String,
        default: ''
      },
      landingBottomText: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        dataToDisplay: '',
        listOfLocations: [{ state: 'Ny', city: 'New  York', available: true }],
        arrayStep: ['Select services', 'Select location', 'Select event', 'Select time', 'Review and Confirm']
      }
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  .app-header{
    background-color: white;
    box-shadow: 0 0 1px 0 rgba(0,0,0,0.2), 0 2px 1px 1px rgba(0,0,0,0.1);
    margin-top: 24px;
    height: auto;
    padding: 24px 48px;
    width: 100%;
    overflow: auto;
  }

  .bread-crumb{
    padding: 8px 0 8px 48px;
    width: 810px;
    margin: auto;

    .list-item-container{
      padding: 0;
      margin: 0;
      display: flex;

      .list-item{
        display: flex;
        margin-right: 16px;
        opacity: 1;
        white-space: nowrap;

        .step-name-breadcrumb{
          &:hover{
            cursor: pointer;
          }
        }
        .arrow-icon{
          margin-left: 8px;
          align-self: center;
          width: 16px;
          height: 16px;
          background: url('../../../../static/img/forward-line.svg') no-repeat center;
        }

        &.pass{
          opacity: 1;
          font-weight: bold;
          .step-name-breadcrumb{
            color: red;
          }
        }

        &.current{
          opacity: 1;
          font-weight: bold;
        }
      }
    }
  }

  .h5-text {
    color: #424242;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: .17px;
    line-height: 28px;
    text-transform: capitalize;
  }

  .select-location-container{
    padding: 24px 40px 48px 40px;
    width: 810px;
    margin: auto;

    .common-card {
      padding: 24px;
    }

    .field-wrapper {
      display: flex;

      .require-field-icon {
        padding-left: 5px;
        color: red;
      }
    }

    .find-nearest-event-card{
      margin: 24px -24px 0;

      .find-nearest-event{
        margin-top: 24px;

        .input-zip-code-container, .btn-find-container-left{
          margin-top: 16px;
        }

        .btn-find-container-left{
          .btn-find{
            padding: 12px 32px;
          }
        }

        .input-zip-code-container{
          display: flex;

          .ap-field-input-wrapper{
            .ap-input-wrapper{
              input[type=number]::-webkit-inner-spin-button,
              input[type=number]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }
              .input{
                margin-top: 0;
                padding: 12px 16px;
                height: unset;
                color: black;
                font-size: 16px;
                line-height: 24px;
                width: 110px;
              }
            }
          }
          .btn-find{
            margin-left: 24px;
            padding: 12px 32px;
            line-height: 24px;
          }
        }
      }
    }

    .full-list-of-locations-container{
      margin: 24px -24px 0;

      .loading-container{
        margin-top: 24px;
      }

      .title-list-of-locations-wrapper{
        display: flex;
        justify-content: space-between;

        .spouse-screening-flushot-container{
          align-self: center;
        }
      }

      .text-availability-of-locations{
        margin-top: 8px;
        color: black;
      }

      @include media-breakpoint-down(xs) {
        margin: 24px 0 0;
      }

      @include media-breakpoint-down(sm) {
        .title-list-of-locations-wrapper{
          flex-direction: column;
          align-items: flex-start;

          .spouse-screening-flushot-container{
            margin-top: 24px;
            align-self: unset;
          }
        }
      }

      .title-list-of-locations{
      }
      .list-of-locations{
        margin-top: 24px;

        .list-item a{
          font-family: "Open Sans";
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 16px;
          word-wrap: break-word;

          &:hover{
            cursor: pointer;
          }
          &:focus{
            text-decoration: underline;
          }
        }
      }
    }

    .more-information-card-container{
      margin: 24px -24px 0;

      @include media-breakpoint-down(xs) {
        margin: 24px 0 0;
      }

      .description{
        margin-top: 16px;
      }
    }

    .supports-section{
      margin-top: 24px;
      margin-bottom: 48px;

      @include media-breakpoint-down(xs) {
        padding-left: 16px;
      }


      .forgot-appointment-time{
        color: red;
        &:hover{
          cursor: pointer;
        }
      }
      .right-side{
        text-align: right;

        @include media-breakpoint-down(sm) {
          text-align: left;
          margin-top: 24px;
        }

        .discover-alternative{
          color: red;
          margin-top: 8px;
          &:hover{
            cursor: pointer;
          }
        }
      }
    }

    .full-event-text {
      color: #6E6E6E;
      font-family: "Open Sans", serif;
      font-size: 16px;
      letter-spacing: 0.1px;
      line-height: 24px;
    }
  }

</style>



// WEBPACK FOOTER //
// SchedulerPreviewSelectLocationPage.vue?44d7fd9a